/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountChartSeriesRowData from './AccountChartSeriesRowData';

/**
 * The AccountChartSeries model module.
 * @module model/AccountChartSeries
 * @version V1
 */
class AccountChartSeries {
    /**
     * Constructs a new <code>AccountChartSeries</code>.
     * @alias module:model/AccountChartSeries
     */
    constructor() { 
        
        AccountChartSeries.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountChartSeries</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountChartSeries} obj Optional instance to populate.
     * @return {module:model/AccountChartSeries} The populated <code>AccountChartSeries</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountChartSeries();

            if (data.hasOwnProperty('metric')) {
                obj['metric'] = ApiClient.convertToType(data['metric'], 'String');
            }
            if (data.hasOwnProperty('dataPoints')) {
                obj['dataPoints'] = ApiClient.convertToType(data['dataPoints'], [AccountChartSeriesRowData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountChartSeries</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountChartSeries</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['metric'] && !(typeof data['metric'] === 'string' || data['metric'] instanceof String)) {
            throw new Error("Expected the field `metric` to be a primitive type in the JSON string but got " + data['metric']);
        }
        if (data['dataPoints']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['dataPoints'])) {
                throw new Error("Expected the field `dataPoints` to be an array in the JSON data but got " + data['dataPoints']);
            }
            // validate the optional field `dataPoints` (array)
            for (const item of data['dataPoints']) {
                AccountChartSeriesRowData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} metric
 */
AccountChartSeries.prototype['metric'] = undefined;

/**
 * @member {Array.<module:model/AccountChartSeriesRowData>} dataPoints
 */
AccountChartSeries.prototype['dataPoints'] = undefined;






export default AccountChartSeries;

